import React from 'react';
import EventVerifyViaOTP from './EventVerifyViaOTP';
import BasicLoader from '../../../../../../util/BasicLoader';
// import EventVerifyViaOTPForEmail from "./EventVerifyViaOTPForEmail";

const prevStyle = {
  position: 'relative',
  top: '46px',
  left: '165px'
};

const nextStyle = {
  position: 'absolute',
  top: '72px',
  left:'333px'
};

export default function VerifyEventSlide(props) {
    if (_.isEmpty(props.event)) {
      return (
        <div className="row">
          <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12 col-xs-12">
            <div className="text-center" style={{marginTop: '30px'}}>
              <BasicLoader />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="row">
            <div className="col-lg-12 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12 col-xs-12">
              <EventVerifyViaOTP
                phone={props.phone}
                country_code={props.country_code ? props.country_code : '+91'}
                eventId={props.eventId}
                isOTPSent={props.isOTPSent}
                isSendingOTP={props.isSendingOTP}
                isVerifyingOTP={props.isVerifyingOTP}
                isPhoneNotEditable={props.isUserPhoneNotEditable}
                editUserPhoneNumber={props.editUserPhone}
                closeUserPhone={props.closeUserPhone}
                verifyEventByPhone={props.verifyEventByPhone}
                verifyOTPCode={props.verifyOTPCode}
                updatePhoneNumber={props.updatePhoneNumber}
                isUpdatingPhone={props.isUpdatingPhone}
                showMessage={props.showMessage}
              />
            </div>
          </div>
        </div>
      );
    }
}
